export default "__VITE_ASSET__D2U5PDz7__"